<script setup lang="ts">
  import ModalAcquista from "@/components/atomics/ModalAcquista.vue";
  import router from '@/router'
  import {Model} from "@/app/Model";

  declare let gtagO: Function;
  declare let frontendConfig: any;

  let model: Model = Model.getReactiveInstance();

  function goPercorsoPenale() : void {
    if (model.abbonatoPenale) {
      router.push("/penale/percorso");
    } else {
      goModuloNonInabbonamento("penale");
    }
  }
  function goPercorsoFamiglia() : void {
    if (model.abbonatoFamiglia) {
      router.push("/famiglia/percorso");
    } else {
      goModuloNonInabbonamento("famiglia");
    }
  }
  function goPercorsoResponsabilita() : void {
    if (model.abbonatoResponsabilita) {
      router.push("/responsabilita/percorso");
    } else {
      goModuloNonInabbonamento("responsabilita");
    }
  }
  function goModuloNonInabbonamento(modulo: string): void {
    let url: string = frontendConfig.urlModuloNonInAbbonamento;
    if (url != "") {
      gtagO({
        event: 'outboundlink',
        target: url,
        posizione: 'home'
      })
      window.open(url, "_blank");
    }
  }

  function viewFamiglia(): boolean {
    return frontendConfig.viewFamiglia;
  }
  function viewResponsabilita(): boolean {
    return frontendConfig.viewResponsabilita;
  }

  function renderClassPenale(): string {
    let out: string = "h-100 p-3 border rounded-2 bordoblu";
    if (!model.abbonatoPenale) out += " moduloInattivo";
    return out;
  }
  function renderClassFamiglia(): string {
    let out: string = "h-100 p-3 border rounded-2 bordoblu";
    if (!model.abbonatoFamiglia) out += " moduloInattivo";
    return out;
  }
  function renderClassResponsabilita(): string {
    let out: string = "h-100 p-3 border rounded-2 bordoblu";
    if (!model.abbonatoResponsabilita) out += " moduloInattivo";
    return out;
  }

  function renderTitlePenale(): string {
    let out: string = "Accedi al Modulo Penale."
    if (!model.abbonatoPenale) out = "Non sei abbonato al Modulo Penale!";
    return out;
  }
  function renderTitleFamiglia(): string {
    let out: string = "Accedi al Modulo Famiglia."
    if (!model.abbonatoFamiglia) out = "Non sei abbonato al Modulo Famiglia!";
    return out;
  }
  function renderTitleResponsabilita(): string {
    let out: string = "Accedi al Modulo Responsabilita."
    if (!model.abbonatoResponsabilita) out = "Non sei abbonato al Modulo Responsabilita!";
    return out;
  }
</script>

<template>
  <div>
    <ModalAcquista></ModalAcquista>

    <div class="container mt-5">
      <!-- Content here -->
      <div class="p-5 mb-4 bg-body-tertiary rounded-2">
        <div class="container-fluid py-2 text-center">
          <h1 class="display-5 fw-bold">Benvenuto su Strategia,<br>
            il tuo assistente virtuale.</h1>
          <p class="fs-4">Analizza il tuo caso giuridico e trova la sentenza perfetta con una velocità senza precedenti.
          </p>
        </div>
      </div>

      <div class="row align-items-md-stretch secondrow">
        <div class="col-md-6 p-3">
          <div :class="renderClassPenale()" @click="goPercorsoPenale()" :title="renderTitlePenale()">
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" class="icon icon sprite-icons" viewBox="0 0 32 32" fill="#133371"><path d="M26.987 9.013c-2.454-2.466-6.12-2.973-9.094-1.56l-1.28-1.28c-.52-.52-1.36-.52-1.88 0l-.106.12C14.44 5 13.333 4 12 4a2.675 2.675 0 00-2.667 2.667c0 .12 0 .24.04.346C8.56 7.48 8 8.333 8 9.333c0 .614.213 1.16.56 1.614-.333.24-.56.613-.56 1.053v1.8a7.987 7.987 0 00-5.333 7.533c0 4.414 3.586 8 8 8 4.413 0 8-3.586 8-8 0-3.48-2.227-6.44-5.334-7.533V12c0-.44-.226-.813-.56-1.053.347-.454.56-1 .56-1.614 0-.12 0-.24-.04-.346.24-.134.44-.32.614-.48A3.96 3.96 0 0116 12v.107c.173.093.333.226.507.333.253-.56.6-1.107 1.053-1.547a5.343 5.343 0 017.547 0 5.344 5.344 0 010 7.547C24.04 19.507 22.667 20 21.24 20c.093.427.093.88.093 1.333 0 .454-.04.894-.093 1.334 2.093 0 4.16-.76 5.747-2.347a7.975 7.975 0 000-11.307zM12 5.333c.733 0 1.333.6 1.333 1.334 0 .44-.226.813-.56 1.053a2.62 2.62 0 00-2.106-1.053c0-.734.6-1.334 1.333-1.334zM9.893 8.28A2.62 2.62 0 0012 9.333c0 .734-.6 1.334-1.333 1.334-.734 0-1.334-.6-1.334-1.334 0-.44.227-.813.56-1.053zM16 21.333a5.332 5.332 0 01-5.333 5.334 5.332 5.332 0 01-5.334-5.334A5.332 5.332 0 0110.667 16 5.332 5.332 0 0116 21.333z" fill="#133371"></path></svg>
            </div>
            <h2>Penale</h2>
            <p>
              Partendo dal capo d'imputazione, potrai avere una panoramica sul tuo caso giuridico (esito del giudizio, durata del procedimento, foro di riferimento e 
              molto altro) per trovare la sentenza più adatta alla tua strategia.
            </p>
          </div>
        </div>
        <div class="col-md-6 p-3">
          <div :class="renderClassFamiglia()" @click="goPercorsoFamiglia()" v-if="viewFamiglia()" :title="renderTitleFamiglia()">
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" class="icon icon sprite-icons" viewBox="0 0 33 32" fill="#133371"><path d="M21.833 5.333c0-1.466 1.2-2.666 2.667-2.666 1.467 0 2.667 1.2 2.667 2.666C27.167 6.8 25.967 8 24.5 8a2.675 2.675 0 01-2.667-2.667zm5.334 24v-8H30.5L27.167 11.2c-.4-1.067-1.334-1.867-2.534-1.867H24.5c-1.2 0-2.133.8-2.533 1.867l-1.2 3.467c1.466.8 2.4 2.266 2.4 4.133v10.667h4v-.134zm-10-14c1.066 0 2-.933 2-2 0-1.066-.934-2-2-2-1.067 0-2 .934-2 2 0 1.067.933 2 2 2zM7.833 8C9.3 8 10.5 6.8 10.5 5.333c0-1.466-1.2-2.666-2.667-2.666a2.675 2.675 0 00-2.666 2.666C5.167 6.8 6.367 8 7.833 8zM10.5 29.333V20h2v-8c0-1.467-1.2-2.667-2.667-2.667h-4A2.675 2.675 0 003.167 12v8h2v9.333H10.5zm8.667 0V24H20.5v-5.333c0-1.067-.933-2-2-2h-2.667c-1.066 0-2 .933-2 2V24h1.334v5.333h4z" fill="#133371"></path></svg>
            </div>
            <h2>Famiglia</h2>
            <p>
              Nell'ambito dei procedimenti di Separazione e Divorzio, potrai avere una panoramica sul tuo caso giuridico (valori degli assegni corrisposti, 
              affidamento figli, durata del procedimento, foro di riferimento e molto altro) per trovare la sentenza più adatta alla tua strategia.
            </p>
          </div>
          <div class="h-100 p-3 bg-body-tertiary border rounded-2 bordogrigio" v-else>
            <div>
              <i class="bi bi-stopwatch icon"></i>
            </div>
            <h2>Coming Soon</h2>
            <p>Nuove materie in arrivo nei prossimi mesi.</p>
          </div>
        </div>
        <div class="col-md-6 p-3">
          <div :class="renderClassResponsabilita()" @click="goPercorsoResponsabilita()" v-if="viewResponsabilita()" :title="renderTitleResponsabilita()">
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" class="icon icon sprite-icons" viewBox="0 0 33 32" fill="#133371"><path d="M16 1.333L4 6.667v8c0 7.4 5.12 14.32 12 16 6.88-1.68 12-8.6 12-16v-8L16 1.333zm0 5.334a4 4 0 110 8 4 4 0 010-8zm6.84 16A12.92 12.92 0 0116 27.893a12.92 12.92 0 01-6.84-5.226A13.555 13.555 0 018 20.627c0-2.2 3.613-4 8-4 4.387 0 8 1.76 8 4-.32.706-.707 1.373-1.16 2.04z"></path></svg>
            </div>
            <h2>Responsabilità Civile</h2>
            <p>
              Nell'ambito dei procedimenti di Responsabilità Civile, potrai avere una panoramica sul tuo caso giuridico (tipologia di danni risarciti, analisi delle 
              somme richieste e delle somme liquidate, durata del procedimento, foro di riferimento e molto altro) per trovare la sentenza più adatta alla tua 
              strategia.
            </p>
          </div>
          <div class="h-100 p-3 bg-body-tertiary border rounded-2 bordogrigio" v-else>
            <div>
              <i class="bi bi-stopwatch icon"></i>
            </div>
            <h2>Coming Soon</h2>
            <p>Nuove materie in arrivo nei prossimi mesi.</p>
          </div>
        </div>

        <!-- 
        <div class="col-md-6 p-3">
          <div class="h-100 p-3 bg-body-tertiary border rounded-2 bordogrigio" @click="openModal()">
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" class="icon icon sprite-icons" viewBox="0 0 32 32" fill="#133371"><path d="M16 1.333L4 6.667v8c0 7.4 5.12 14.32 12 16 6.88-1.68 12-8.6 12-16v-8L16 1.333zm0 5.334a4 4 0 110 8 4 4 0 010-8zm6.84 16A12.92 12.92 0 0116 27.893a12.92 12.92 0 01-6.84-5.226A13.555 13.555 0 018 20.627c0-2.2 3.613-4 8-4 4.387 0 8 1.76 8 4-.32.706-.707 1.373-1.16 2.04z" fill="#133371"></path></svg>
            </div>
            <h2>Responsabilità civile</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
          </div>
        </div>
        <div class="col-md-6 p-3">
          <div class="h-100 p-3 bg-body-tertiary border rounded-2 bordogrigio" @click="openModal()">
            <div>
              <i class="bi bi-car-front-fill icon"></i>
            </div>
            <h2>Responsabilità da circolazione stradale</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
          </div>
        </div> -->
      </div>

      <div class="row p-3"></div>
    </div>

    <button type="button" id="triggerModal" class="not-visible" data-bs-toggle="modal" data-bs-target="#acquistaModal"></button>
  </div>
</template>